import React from "react";
import { Box } from "Components/Base/Layout/Box";
import { CategoryChip } from "./Chips";

const ActivityCategories = ({ categories }) => {
  if (!Array.isArray(categories) || categories.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        marginTop: "4px",
      }}
    >
      {categories.map((c) => (
        <CategoryChip key={`cat-${c.itemId}`} label={c.itemIdTitle} />
      ))}
    </Box>
  );
};

export default ActivityCategories;
